// Never copy arbitrary error strings: even name/code can contain request data.
const ERROR_NAMES = new Set(['AxiosError', 'CanceledError', 'Error', 'TypeError'])
const ERROR_CODES = new Set([
  'ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT',
  'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL', 'ECONNRESET', 'ENOTFOUND', 'EAI_AGAIN', 'ECONNREFUSED',
])
const HTTP_METHODS = new Set([
  'GET', 'HEAD', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS', 'CONNECT', 'TRACE',
])
const REQUEST_ID_PATTERN = /^[A-Za-z0-9._-]{1,128}$/

export const buildSafeApiErrorMetadata = (error) => {
  const metadata = {}
  if (ERROR_NAMES.has(error?.name)) metadata.name = error.name
  if (ERROR_CODES.has(error?.code)) metadata.code = error.code

  const status = error?.response?.status
  if (Number.isInteger(status) && status >= 100 && status <= 599) {
    metadata.status = status
  }
  const method = typeof error?.config?.method === 'string'
    ? error.config.method.toUpperCase()
    : undefined
  if (HTTP_METHODS.has(method)) metadata.method = method

  // Axios normalizes response header names; support plain synthetic headers too.
  const headers = error?.response?.headers
  const requestId = headers?.['x-request-id'] ?? headers?.['X-Request-Id']
  if (typeof requestId === 'string' && REQUEST_ID_PATTERN.test(requestId)) {
    metadata.requestId = requestId
  }
  return metadata
}
